// Romantik Türkçe mesajlar
export const romanticMessages = [
  "Seninle geçirdiğim her an hayatımın en güzel ve en değerli anları.",
  "Dünden daha çok, yarından daha az seviyorum seni.",
  "Dünyadaki bütün güzellikler sende toplanmış sevgilim.",
  "Her zerrene aşık ve her zerrene kurban olurum.",
  "Benim ailem, benim her şeyimsin.",
  "Huzur ve mutluluk kaynağımsın aşkım.",
  "İyi ki varsın, iyi ki o güzel ellerinle hayatıma dokundun sevgilim.",
  "Gülüşün yeryüzündeki cennetim.",
  "Yanında olduğum zaman evimde olduğumu anlıyorum.",
  "Yanında çocuk gibi olduğum tek insan, seni çok seviyorum.",
  "Sesini duymak aşırı derecede huzur veriyor bana aşkım.",
  "Gülüşün, gülerken kısılan gözlerin çok güzel güzelim.",
  "Hayranlık, gurur, aşk, sevgi ve en güzel hislerin hepsinin sebebi sensin yavrum.",
];
